var router = require('pjax').Router;
var auditIndex = require('./index.js');

router.get('audit', auditIndex);
